<!--  新版界面首页 -->
<template>
  <div class="administrat mainContent">
    <div v-if="!showMore" class="main_content">
      <div class="query-box search">
        <div class="date_search">
          <!-- 查询条件 -->
          <SearchDate @handleSearch="handleSearch" :searchDate="currenNode" ref="searchDate"></SearchDate>
        </div>
        <!-- 机构树搜索 -->
        <div class="searchTree">
          <SearchTree @currentNode="currentNode"></SearchTree>
        </div>
        <el-button type="primary" class="serachBtn" size="small" @click="handleChild">
          {{ $t('query') }}
        </el-button>
      </div>
      <!--  左侧 -->
      <transition name="moveL">
        <div class="left_li" v-show="flag2">
          <!-- 设备告警状态统计 -->
          <div class="content_box equipment_statu">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.equipmentTitle }}</div>
              </div>
              <div
                class="check_more"
                v-if="traceData.allData.length > 5"
                @click="checkMore(mainTitle.equipmentTitle, traceData, '3dbar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <!-- 设备告警状态统计立体柱状图 -->
            <AlarmStatu class="alarm_statu" :traceData="traceData" :unit="traceData.unit"></AlarmStatu>
          </div>
          <!-- 纯定位显示 -->
          <!--  进入禁区统计 -->
          <div class="content_box" v-if="isOnlySupportPosition">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.planeTitle }}: {{ alarmTotal.planeTotle }}</div>
              </div>
              <div
                class="check_more"
                v-if="alarmTotal.planeTotle > 4"
                @click="checkMore(mainTitle.planeTitle, allPlaneList, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="equipment_num">
              <div class="amount" v-for="(item, indx) in planeList" :key="indx">
                <div class="num">{{ item.number }}</div>
                <el-tooltip class="item" effect="dark" :content="item.userName" placement="top-start">
                  <div class="equip_name">{{ item.userName }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div v-else class="import-event">
            <!-- 重要事件 -->
            <div class="content_box event_num" v-if="!isOnlySupportIH5">
              <div class="title_box">
                <div class="new_title">{{ $t('StatisticsImportantEvents') }}</div>
              </div>
              <ImportantEvent :currenNode="currenNode"></ImportantEvent>
            </div>
            <!--  设备状态告警 -->
            <div class="content_box healty_statu" v-if="isOnlySupportIH5">
              <DeviceStatusAlarm :currenNode="currenNode"></DeviceStatusAlarm>
            </div>
          </div>
        </div>
      </transition>
      <div class="center-li ih5-center">
        <!-- 设备数量统计-->
        <div class="content_box helemt-num">
          <!-- <div class="title_box">
            <div class="new_title">{{ $t('EquipmentQuantityStatistics') }}</div>
          </div> -->
          <div class="num_statis">
            <div class="intelligence">
              <div class="equipments">
                {{ $t('TotalNumberDevices') }}: <span class="numbers">{{ totleEquip.totle }}</span>
              </div>
              <div class="equipments">
                {{ $t('IntelligentSafetyHelmet') }}: <span class="numbers">{{ totleEquip.safetyHat }}</span>
              </div>
              <!-- 如果仅支持IPC设备不展示执法仪 -->
              <div class="equipments">
                {{ $t('SiteEnforcementRecorder') }}: <span class="numbers">{{ totleEquip.lowEnfo }}</span>
              </div>
            </div>
            <div class="pie_chart">
              <!-- 设备数量统计 3D饼状图 -->
              <EquipmentNum
                :chartId="alarmsChart"
                :echartData="onlineData"
                :seriesSize="160"
                :legendY="16"
              ></EquipmentNum>
            </div>
          </div>
        </div>

        <!-- 人员进出实时记录 定位设备专属 -->
        <div class="content_box talk_news" v-if="isOnlySupportPosition">
          <div class="record">
            <div class="title_box">
              <div class="new_title">{{ $t('Realtimerecordpersonnel') }}</div>
            </div>
            <div
              class="check_more"
              v-if="accessParam.allPage > 6"
              @click="checkMore(mainTitle.accessTitle, '', 'inOut')"
            >
              {{ $t('SeeMore') }}>
            </div>
          </div>
          <div class="healthy_alarm">
            <PersonInOut :currenNode="currenNode"></PersonInOut>
          </div>
        </div>
        <!-- 语音消息-->
        <div class="content_box talk_news" v-else>
          <div class="record">
            <div class="title_box">
              <div class="new_title">{{ mainTitle.talkTitle }}</div>
            </div>
            <div
              class="check_more"
              v-if="amountList.chat > 4 || amountList.voice > 4 || amountList.broadcast > 4"
              @click="checkMore(mainTitle.talkTitle, newsData, 'info')"
            >
              {{ $t('SeeMore') }}>
            </div>
          </div>
          <div class="one_talk">
            <div class="talk_num">
              <div class="amount">
                <div class="num">{{ amountList.voice }}</div>
                <div class="equip_name">{{ $t('VoiceMessageRecording') }}</div>
              </div>
              <!-- 不具备 语音通话记录 权限时，屏蔽该模块 -->
              <div v-has="'sys:new:comunicate:groupchat'" class="amount">
                <div class="num">{{ amountList.chat }}</div>
                <div class="equip_name">{{ $t('VoiceCallRecord') }}</div>
              </div>
              <div class="amount">
                <div class="num">{{ amountList.broadcast }}</div>
                <div class="equip_name">{{ $t('BroadcastRecord') }}</div>
              </div>
              <div class="amount" v-if="!isOnlySupportIH5 && !isOnlySupportIPC">
                <div class="num">{{ amountList.broadcastWord }}</div>
                <div class="equip_name">{{ $t('BroadcastWordRecord') }}</div>
              </div>
            </div>
            <div class="line"></div>
            <div class="unread">
              <!-- 具体语音记录信息组件 -->
              <IntercomRecord :currenNode="currenNode"></IntercomRecord>
            </div>
          </div>
        </div>
      </div>

      <!--  右侧 -->
      <transition name="moveR">
        <div class="right_li" v-show="flag2">
          <div class="content_box person-static">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ $t('attendanceStatistics') }}</div>
              </div>
              <div class="attendance-time">
              <el-date-picker
                v-model="StaticSearchTime"
                :placeholder="$t('startDate')"
                type="date"
                value-format="yyyy-MM-dd"
                popper-class="date-picker-blue-hw"
                :clearable="true"
              >
              </el-date-picker>
            </div>
              <div class="check_more" v-if="attenceStaticShow"  @click="checkMore($t('attendanceStatistics'), '', 'static')">
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <!-- 考勤统计组件 -->
          <PersonStatic
            :currenNode="currenNode"
            :StaticSearchTime="StaticSearchTime"
            ref="attendanceStatic"
            @showMoreStatic="showMoreStatic"
            :isHome="true"
          ></PersonStatic>
            <!-- 人员进出管理组件 -->
            <!-- <PersonnelAccess @personelMore="personelMore"></PersonnelAccess> -->
          </div>
          <div class="content_box active_time" v-if="!isOnlySupportIH5 && !isOnlySupportPosition">
            <div class="title_box">
              <div class="new_title">{{ $t('StatisticsPersonnelPeriods') }}</div>
            </div>
            <!-- 人员活跃时段折线图组件 -->
            <ActivePeriod :currenNode="currenNode"></ActivePeriod>
          </div>
          <!--  设备运行时间 -->
          <div class="content_box" v-if="isOnlySupportIH5 || isOnlySupportPosition">
            <div class="title_box">
              <div class="new_title">{{ $t('EquipmentRunningTime') }}</div>
            </div>
            <div class="pie_chart">
              <EquipmentNum
                chartId="equipmentRun"
                :echartData="quipmentRunData"
                :seriesSize="160"
                :legendY="16"
              ></EquipmentNum>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="showMore" class="main_content">
      <CheckMore
        @backHome="backHome"
        :moreTitle="moreTitle"
        :type="echartType"
        :echartData="echartData"
        :currenNode="currenNode"
        :StaticSearchTime="StaticSearchTime"
      ></CheckMore>
    </div>
  </div>
</template>

<script>
// 依赖组件
import ImportantEvent from '@/views/new-home/ImportantEvent.vue'
import PersonnelAccess from '@/views/new-home/PersonnelAccess.vue'
import SearchTree from '@/views/new-home/SearchTree.vue'
import ActivePeriod from '@/views/new-home/ActivePeriod.vue'
import EquipmentNum from '@/views/new-home/EquipmentNum.vue'
import AlarmStatu from '@/views/new-home/AlarmStatu.vue'
import SearchDate from '@/views/new-home/SearchDate.vue'
import CheckMore from '@/views/new-more/CheckMore.vue'
import IntercomRecord from '@/views/new-home/IntercomRecord.vue'
import DeviceStatusAlarm from '@/views/new-device/DeviceStatusAlarm'
import PersonInOut from '@/views/new-person/PersonInOut.vue'
import PersonStatic from '@/views/new-person/PersonAttendanceStatic.vue'
// 依赖工具
import { nowDate, beforeMonthDate,formatDate } from '@/util/date'
import { findStatus } from '@/api/Cockpit'
import { deviceCountType, deviceCountTime } from '@/api/new-device/newDevice'
import { recordFind } from '@/api/new-home/newHome'
import { findAlertNum, findAlertType } from '@/api/monitor'
import { emergencyHelpPage, alertCountPage } from '@/api/new-warn/newWarn'
import { mapGetters } from 'vuex'
import { getGeoFences } from '@/api/log'
export default {
  data() {
    return {
      // 滑动显示
      flag2: false,
      // 查看更多的 框的标题，方便传值
      mainTitle: {
        equipmentTitle: this.$t('EquipmentAlarmStatusStatis'),
        talkTitle: this.$t('VoiceMessage'),
        personnel: this.$t('PersonnelAccessManagement'),
        planeTitle: this.$t('OutPlaneAlarm'),
        accessTitle: this.$t('Realtimerecordpersonnel'),
      },
      currenNode: {
        id: '154827590683746304',
        startTime: beforeMonthDate() + ' 00:00:00',
        endTime: nowDate() + ' 23:59:59',
      },
      alarmsChart: 'equipmentNum',
      // 对讲数据
      amountList: { broadcast: 0, voice: 0, chat: 0, broadcastWord: 0 },
      // 未读消息列
      newsData: [],
      // 在线设备统计数据
      onlineData: [],
      // 设备数量统计数据
      totleEquip: { safetyHat: 0, lowEnfo: 0, totle: 0 },
      personMore: false,
      // 告警类型数据
      alertTypeList: [],
      // 告警数字数据
      alertNum: [],

      sechDate: {
        pageNum: 1,
        pageSize: 6,
      },
      // 设备告警状态
      traceData: {
        distantData: [],
        traceXAxis: [],
        allData: [],
        allXData: [],
        unit: this.$t('second'),
      },
      // 显示更多的内容弹窗
      showMore: false,
      // 更多的标题传值
      moreTitle: '',
      echartType: '3dbar',
      echartData: [],
      SearchDate: {
        pageNum: 1,
        pageSize: 1000,
      },
      // / 统计设备运行时间情况
      quipmentRunData: [],
      alarmTotal: {
        heartTotlal: '0',
        bloodTotlal: '0',
        hatTotlal: '0',
        electricitTotlal: '0',
        hitTotlal: '0',
        dropTotlal: '0',
        staticTotlal: '0',
        helpTotlal: '0',
        planeTotle: '0',
      },
      // 进入禁区告警统计总数
      allPlaneList: {
        barId: 'helpId',
        color: ['#FFD96A'],
        unit: this.$t('second'),
        allXData: [],
        allBarData: [],
        lineName: this.$t('OutPlaneAlarm'),
      },
      // 进入禁区告警统计
      planeList: [],
      // 请求人员进出参数（电子围栏log）
      accessParam: { currentPage: 1, pageSize: 6, allPage: 0 },
      // 考勤统计参数
      StaticSearchTime: nowDate(),
      attenceStaticShow: false,
    }
  },
  computed: {
    ...mapGetters(['isOnlySupportIPC', 'isDefaultTheme', 'isOnlySupportIH5','isOnlySupportPosition']),
  },
  components: {
    ImportantEvent,
    PersonnelAccess,
    SearchTree,
    ActivePeriod,
    EquipmentNum,
    AlarmStatu,
    SearchDate,
    CheckMore,
    IntercomRecord,
    DeviceStatusAlarm,
    PersonInOut,
    PersonStatic
  },
  methods: {
    // 日期子组件触发 处理事件
    handleChild() {
      this.$refs.searchDate.searchData()
    },
    // 考勤统计 是否显示更多按钮
    showMoreStatic(type) {
      console.log(type)
      this.attenceStaticShow = type
    },
    // 人员进出
    getAccess() {
      let param = {
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: formatDate(this.currenNode.endTime),
        pageNum: this.accessParam.currentPage,
        pageSize: this.accessParam.pageSize,
      }
      // 获取电子围栏table数据
      getGeoFences(param).then(res => {
        if (res.state === 0) {
          this.accessParam.allPage = res.value.totalElements
        }
      })
    },
    // 告警用户明细以及总数统计
    getalertCount(type) {
      // NOSONAR
      let param = {
        pageNum: this.SearchDate.pageNum,
        pageSize: this.SearchDate.pageSize,
        alertType: 'FENCE',
        startTime: this.currenNode.startTime,
        endTime: this.currenNode.endTime,
        ouId: this.currenNode.id,
      }
      // 需要处理结束时间的是时分秒
      if (param.endTime) {
        param.endTime = param.endTime.replace('00:00:00', '23:59:59')
      }
      alertCountPage(param).then(res => {
        if (res.state === 0) {
          this.allPlaneList.allXData = []
          this.allPlaneList.allBarData = []
          for (var itemFence of res.data.pageData.list) {
            this.allPlaneList.allXData.push(itemFence.userName)
            this.allPlaneList.allBarData.push(itemFence.number)
          }
          if (this.showMore === false && res.data.pageData.total > 4) {
            this.planeList = res.data.pageData.list.slice(0, 4)
          } else {
            this.planeList = res.data.pageData.list
          }
          this.alarmTotal.planeTotle = res.data.pageData.total
        }
      })
    },
    refreshData() {
      this.getAlertType()
      this.getCountType()
      this.getEquipment()
      // this.getMediaData()
      this.getAlertNum()
      this.getRecordFind()
      this.getdeviceTime()
      this.getalertCount()
      this.getAccess()
    },
    // 结构树当前节点（用户头盔）
    currentNode(item) {
      this.currenNode.id = item.id
      this.currenNode = Object.assign({}, this.currenNode)
      this.refreshData()
    },
    // 返回
    backHome() {
      this.showMore = false
      // this.refreshData()
    },
    // 查看更多
    checkMore(title, data, type) {
      this.moreTitle = title
      this.echartType = type
      this.showMore = true
      this.echartData =  data
      // this.refreshData()
    },
    // // 人员检出管理 是否显示查看更多
    personelMore(val) {
      this.personMore = val
    },
    // 日期子组件触发 处理事件
    handleSearch(val) {
      this.currenNode.startTime = val.logTimestampBegin
      this.currenNode.endTime = val.logTimestampEnd
      this.currenNode = Object.assign({}, this.currenNode)
      this.refreshData()
      // this.getMediaData()
    },

    // 查询该机构的设备是否在线数
    getEquipment() {
      findStatus({ ouId: this.currenNode.id }).then(res => {
        if (res.state === 0) {
          this.onlineData = []
          for (let item of res.data) {
            let num = Number(item.number)
            if (item.status === '2' && num !== 0) {
              this.onlineData.push({
                y: num,
                name: this.$t('Unbound'),
                color: '#35E878',
              })
            } else if (item.status === '1' && num !== 0) {
              this.onlineData.push({
                y: num,
                name: this.$t('onLine'),
                color: '#2096FF',
              })
            } else if (item.status === '0' && num !== 0) {
              this.onlineData.push({
                y: num,
                name: this.$t('offLine'),
                color: '#FFD96A ',
              })
            }
          }
        }
      })
    },
    // 查询设备数
    getCountType() {
      let param = { ouId: this.currenNode.id }
      deviceCountType(param).then(res => {
        if (res.state === 0) {
          this.totleEquip.safetyHat = res.data.helmet
          this.totleEquip.lowEnfo = res.data.pda
          this.totleEquip.totle = res.data.total
        }
      })
    },
    // 获取告警类型
    async getAlertType() {
      findAlertType().then(res => {
        if (res.state === 0) {
          this.alertTypeList = res.data
          // console.log('类型', res.data)
        }
      })
    },
    // 获取告警数量 H5
    async getAlertNum() {
      this.alertNum = []
      let param = {
        ouId: this.currenNode.id,
        status: '',
        startTime: this.currenNode.startTime,
        endTime: this.currenNode.endTime,
      }
      findAlertNum(param).then(res => {
        if (res.state === 0) {
          this.alertNum = res.data
          this.getemergencyHelp()
        }
      })
    },
    // 循环遍历告警类型和数量
    alertList(data) {
      this.traceData = {
        distantData: [],
        traceXAxis: [],
        allData: [],
        allXData: [],
        unit: this.$t('second'),
      }
      for (let item of data) {
        if (item.alertType !== 'total') {
          // 由请求回来的告警类型数据 添加成新的数据
          for (let itemType of this.alertTypeList) {
            //  {alertType: "impact", number: 2} === {alertCode: "impact", alertName: "撞击告警"}
            if (item.alertType === itemType.alertCode) {
              this.traceData.allData.push(item.number)
              this.traceData.allXData.push(this.$t(itemType.alertName))
            }
          }
        }
      }
      if (this.showMore === false && this.traceData.allXData.length > 6) {
        this.traceData.distantData = this.traceData.allData.slice(0, 6)
        this.traceData.traceXAxis = this.traceData.allXData.slice(0, 6)
      } else {
        this.traceData.traceXAxis = this.traceData.allXData
        this.traceData.distantData = this.traceData.allData
        // this.echartData = this.traceData
      }
    },
    // 请求一键求助数据
    getemergencyHelp() {
      let param = {
        pageNum: this.SearchDate.pageNum,
        pageSize: this.SearchDate.pageSize,
        startTime: this.currenNode.startTime,
        endTime: this.currenNode.endTime,
        ouId: this.currenNode.id,
      }
      if (param.endTime) {
        param.endTime = param.endTime.replace('00:00:00', '23:59:59')
      }
      emergencyHelpPage(param).then(res => {
        if (res.state === 0 && res.value.sumData !== 0) {
          let alertAdd = []
          for (var item of this.alertNum) {
            alertAdd.push(item.alertType)
            if (item.alertType === 'sos') {
              item.number = item.number + res.value.sumData
            }
          }
          setTimeout(() => {
            if (alertAdd.indexOf('sos') === -1) {
              this.alertNum.push({
                number: res.value.sumData,
                alertType: 'sos',
              })
              // 数据降序排序
              this.alertNum.sort(function(a, b) {
                return b.number - a.number
              })
            }
          }, 300)
        }
      })
      setTimeout(() => {
        this.alertList(this.alertNum)
      }, 600)
    },
    // 对讲消息
    getRecordFind() {
      let param = {
        startTime: this.currenNode.startTime,
        endTime: this.currenNode.endTime,
        pageNum: this.sechDate.pageNum,
        pageSize: this.sechDate.pageSize,
      }
      recordFind(param).then(res => {
        if (res.state === 0) {
          this.newsData = res.data.pageData.list
          this.amountList.broadcast = res.data.sumData.broadcast ? res.data.sumData.broadcast : 0
          this.amountList.voice = res.data.sumData.voice ? res.data.sumData.voice : 0
          this.amountList.chat = res.data.sumData.chat ? res.data.sumData.chat : 0
          this.amountList.broadcastWord = res.data.sumData.broadcastWord ? res.data.sumData.broadcastWord : 0
        }
      })
    },
    // 统计设备运行时间
    getdeviceTime() {
      deviceCountTime({ ouId: this.currenNode.id }).then(res => {
        if (res.state === 0) {
          this.quipmentRunData = []
          if (res.data.year !== 0) {
            this.quipmentRunData.push({
              y: res.data.year,
              name: this.$t('HalfYeaOneYear'),
              color: '#2096FF',
            })
          }

          if (res.data.halfYear !== 0) {
            this.quipmentRunData.push({
              y: res.data.halfYear,
              name: this.$t('ThreeToSixMonths'),
              color: '#FFD96A',
            })
          }

          if (res.data.overYear !== 0) {
            this.quipmentRunData.push({
              y: res.data.overYear,
              name: this.$t('OneYarAndAbove'),
              color: '#35E878',
            })
          }

          if (res.data.quarter !== 0) {
            this.quipmentRunData.push({
              y: res.data.quarter,
              name: this.$t('WithinThreeMonths'),
              color: '#3CFFC4',
            })
          }
        }
      })
    },
  },
  mounted() {
    this.flag2 = true
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.mainContent
  position relative
  height 100%
  overflow hidden
  .main_content
    height 100%
    .query-box
      display flex
      align-items: center
      position relative
      width calc(100% - 40px)
      margin 0 20px
      margin-top 20px
      padding 8px 0
      pointer-events: auto
      background: #fff;
      box-shadow: 0 0.01041667rem 0.03125rem 0 rgba(0,54,103,0.1);
      >>>.el-button--small
        padding: 10px 15px;/*no*/
      .date_search
        pointer-events: auto
      .serachBtn
        position absolute
        right 20px
        margin-left 10px
  .content_box
    width 500px
    height 47.5%
    margin-left 20px
    margin-top 20px
    pointer-events: auto
    .record
      position relative
      .check_more
        position: absolute
        right: 15px
        top 50%
        transform: translate(0,-50%)
        text-align: center
        line-height: 28px
        padding: 0 7px
        border-radius: 2px
        font-weight: bold
        font-size: 14px
        border-radius: 4px;
        cursor pointer
      .attendance-time
        position: absolute
        right: 100px
        top 50%
        transform: translate(0,-50%)
        >>>.el-date-editor
          width 125px!important;/*no*/
          .el-input__inner
            height 30px
            line-height 30px
            padding 12px 5px 12px 0!important;
            padding-left 30px!important;/*no*/
        >>>.el-input__icon
          line-height 30px
    .title_box
      .new_title
        height 46px
        line-height 46px
        padding-left 56px
        font-size: 18px;
        font-weight: bold
    .pie_chart
      height: calc(100% - 80px)
    .equipment_num
      width 100%
      height: calc(100% - 46px)
      .amount
        width 50%
        text-align center
        float left
        margin-top 16px
        .num
          width 120px
          height 120px
          margin 0 auto
          line-height 120px
          font-size: 30px
          color: #fff
          font-weight 600
          bg-image-full('~@/icon/home/circular.png')
        .equip_name
          width 100%
          margin-top 6px
          color #333
          font-size: 16px
          font-weight: bold
          overflow:hidden
          white-space:nowrap
          text-overflow:ellipsis
      .amount:last-child
        margin-right 0
  .equipment_statu
    .alarm_statu
      height: calc(100% - 46px)
  .content_box:first-child
    margin-top 0px
  .left_li
    float left
    width 500px
    height calc(100% - 100px)
    padding-top 20px
    .import-event
      margin-top 20px
      height 47.3%
      .content_box
        height 100%
  .num_statis
    height calc(100% - 46px)
    display: flex
    margin-top: 16px
    text-align: center
    .numbers
      display: block
      font-weight: bold;
      color: #49C5FF;
      font-size: 38px
      line-height: 44px;
      text-shadow: 0px 4px 0px rgba(4,244,254,0.3);
      background-image:-webkit-linear-gradient(bottom,#5155DF,#04F4FE);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    .equip_one
      font-size: 20px
      font-weight: bold
    .pie_chart
      height: calc(100% - 20px)
      width calc(100% - 170px)
    .intelligence
      color: #333333
      text-align: center
      margin-left 20px
      line-height: 44px
      .equipments
        width: 260px;
        height: 90px;
        margin-top: 10px
        background: linear-gradient(90deg, #C6E9FF 0%, #EEF5FE 100%);
        background url('~@/icon/home/img_data.png')no-repeat
        background-size: 100% 100%;
        -webkit-background-size: 100% 100%;
        font-weight: bold;
        font-size: 20px;
      .equip_info
        margin-top 10px
      .equip_name
        text-align: left
        line-height: 36px
        margin-left: 22px
  .one_talk
    // display: flex
    height calc(100% - 60px)
    width 100%
    // margin-top 20px
  .talk_num
    width calc(100% - 20px)
    // width 141px
    display flex
    justify-content: space-around
    margin 10px 8px 0
    .amount
      // width 32%
      text-align center
      .num
        width 107px
        height 98px
        line-height 100px
        margin 0 auto
        font-size: 32px
        color: #FFFFFF
        bg-image-full('~@/icon/home/circular.png')
      .equip_name
        margin-top 10px
        font-size: 16px
        font-weight: bold
        text-align: center
  .center-li
    width: calc(100% - 1080px)
    height calc(100% - 100px)
    float: left
    margin 0 20px
    .content_box
      width 100%
      height 47.5%
    .helemt-num
      height 47.5%
      margin-top 20px
      background url('~@/icon/home/default_bg.png')no-repeat
      background-size: 100% 100%;
      -webkit-background-size: 100% 100%;
    .healthy_alarm
      height: 47.5%
      margin-left: 26px
    .talk_news
      height 47.5%
      .line
        width: 90%;
        height: 1px;
        margin 10px auto
        background: #CBDFEC;
    .unread
      width: 96%
      height: 45%
      overflow auto
      margin 0 auto
      font-size: 14px
      line-height: 24px
  .right_li
    float: left
    width 500px
    height calc(100% - 100px)
    padding-top 20px
    .content_box
      margin-left: 20px
    .content_box:first-child
      margin-top 0px

// 深色样式
.theme-dark
  .mainContent
    .main_content
      .query-box
        background: rgba(0,42,150,0.8);
        box-shadow: 0 0.01041667rem 0.03125rem 0 rgba(0,54,103,0.1);
  .center-li
    .helemt-num
      background url('~@/icon/home/img_bg.png')no-repeat
  .num_statis
    .numbers
      color: #00E4FF;
      text-shadow: 0px 4px 0px rgba(0,19,65,0.3);
      background-image:-webkit-linear-gradient(bottom,#5591EF,#04F4FE);
    .intelligence
      color: #fff
      .equipments
        background: linear-gradient(90deg, #295AFE 0%, #00113F  100%);
  .talk_num
    .amount
      .num
        color: #00E4FF
        bg-image-full('~@/icon/home/ic_round.png')
</style>
